module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isInputed) ? _c('div', {
    staticClass: "fullPage",
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('img', {
    staticClass: "back",
    attrs: {
      "src": require("../../assets/img/team/back.png")
    },
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tit"
  }, [_vm._v("兑换礼包中的奖品")]), _vm._v(" "), _c('p', {
    staticClass: "hint"
  }, [_vm._v("集齐10Q点可以兑换1Q币，集齐20Q点可以兑换2Q币，依次类推。未满10的倍数不予兑换")]), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_vm._v("已经提交QQ号，小悠会在活动结束后，直接将Q币充值到填写的QQ账户中。")]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v("你的QQ号：" + _vm._s(_vm.qqNum))])]), _vm._v(" "), _c('footer', [_vm._v("请于2018.01.25前提交你的联系方式，过期后奖品作废。如有其它问题请联系小悠，小悠QQ：3196426910")])])]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-47559321", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47559321"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layer/inputed.vue
// module id = 387
// module chunks = 6